import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import useInView from '../../hooks/useInView';
import styles from './ReviveStatement.module.css';

/**
 * REVIVE + Isaiah 57:15 — full-width saturated blue section,
 * mirroring Social Dallas's full-width #3a4faa block pattern.
 * Cream type on blue ground. No blue on type.
 */
export default function ReviveStatement() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const wordX = useTransform(scrollYProgress, [0, 1], ['-2%', '2%']);
  const [bodyRef, bodyIn] = useInView({ threshold: 0.3 });

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.shell}>
        <motion.h2 className={styles.wordmark} style={{ x: wordX }}>
          {['R', 'E', 'V', 'I', 'V', 'E'].map((letter, i) => (
            <span
              key={i}
              className={styles.letter}
              style={{ '--d': `${0.05 + i * 0.07}s` }}
            >
              {letter}
            </span>
          ))}
        </motion.h2>

        <div
          ref={bodyRef}
          className={`${styles.verseBlock} ${bodyIn ? styles.verseIn : ''}`}
        >
          <blockquote className={styles.verse}>
            For this is what the high and exalted One says, He who lives forever,
            whose name is holy: <em>"I live in a high and holy place, but also
            with the one who is contrite and lowly in spirit, to revive the
            spirit of the lowly and to revive the heart of the contrite."</em>
          </blockquote>
          <cite className={styles.verseRef}>Isaiah 57:15, NIV</cite>
        </div>
      </div>
    </section>
  );
}
